import { mapFlagName } from "../rules_utils"

const ListPresenceRuleCard = (props) => {
    const { step, decision, flags, description } = props
    return (
        <div className="inbox__cell--left" style={{ paddingBottom: "10px" }}>
            <p className="data-field" style={{ marginBottom: "8px" }}>
                <span className="data-field__label dialogTitle">
                    <b>
                        {step}
                    </b>
                </span>
            </p>
            <p className="data-field" style={{paddingBottom: '10px'}}>
                <span className="data-field__label">
                    Indicadores:
                </span>
                <ul>
                    {
                        flags.map((flag) => (
                            <li key={flag} style={{ marginLeft: '30px', marginTop: '5px' }}>
                                <span className="data-field__value">
                                    {mapFlagName(flag)}
                                </span>
                            </li>
                        ))
                    }
                </ul>
            </p>
            <p className="data-field">
                <span className="data-field__label">
                    Decisão:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    {decision}
                </span>
            </p>
            <p>
                <span className="data-field__label">
                    Descrição:
                </span>
                <span className="data-field__value" style={{ paddingLeft: '5px' }}>
                    {description}
                </span>
            </p>
        </div>
    )
}

export default ListPresenceRuleCard